import { render, staticRenderFns } from "./vaIframe.vue?vue&type=template&id=044189f3&scoped=true"
import script from "./vaIframe.vue?vue&type=script&lang=js"
export * from "./vaIframe.vue?vue&type=script&lang=js"
import style0 from "./vaIframe.vue?vue&type=style&index=0&id=044189f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044189f3",
  null
  
)

export default component.exports